import React, {Component,PropTypes} from 'react'
import firebase from '../../config/database'


class Esponsors extends Component {

  constructor(props) {
    super(props);
    this.state = {
      values:props.value.split(","),
      opciones:[],
      idclinica:"",
    };
    this.handleChange=this.handleChange.bind(this);
    this.renderARadio=this.renderARadio.bind(this);
  }

  //Change events on all inputs
  handleChange(event) {
    //Find if we have this elemet already selected
    var selectedItems=this.state.values;
    var indexOfItem=selectedItems.indexOf(event.target.value);
    if(indexOfItem==-1){
      //It doesn't exist, add it
      selectedItems.push(event.target.value);
    }else{
      //Remove it, make it unselected
       selectedItems.splice(indexOfItem, 1);
    }
    this.setState({value: selectedItems});
    console.log(selectedItems.toString());
    this.props.updateAction(this.props.theKey,selectedItems.toString());
  }

getidclinica(){

       

         // EXTRAER LA ID CLINICA PARA PASARLO COMO TOPIC 

             

             

        }


  findFirestoreRelatedData(){

    console.log("Coger Opciones");
     
     var db = firebase.app.firestore();
     //COLLECTIONS - GET DOCUMENTS 
     var optionsFromFirebse=[];
     var _this=this;
   
   

       // GET ID CLINICA

      

     
// GET COLLECTIONS


                       db.collection("esponsors").get().then(function(querySnapshot) {
                         querySnapshot.forEach(function(doc) {
                             var currentDocument=doc.data();
                             currentDocument.uidOfFirebase=doc.id;
        

                             var newOption={
                                value:currentDocument.idesponsor,
                                name:currentDocument.nombre_esponsor,
                            }
                      //       console.log(newOption);
                              optionsFromFirebse.push(newOption);
 
                          });
                      _this.setState({opciones:optionsFromFirebse})
                        });
 
              

 }



  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  renderARadio(value){
    return (
      <div className="checkbox" key={value.value}>
        <label>
          <input type="checkbox" name={this.props.theKey} value={value.value} checked={this.state.values.indexOf(value.value)>-1}  onChange={this.handleChange} />
          <span className="checkbox-material"><span className="check"></span></span> {this.capitalizeFirstLetter(value.name)}
        </label>
      </div>
    )
  }


  componentDidMount(){
    if(this.props.isFirestore){
      
      this.findFirestoreRelatedData();
    }else{
     
      this.findFirebaseRelatedData();
    }
  }


  render() {
    return (
            <div className="form-group label-floating is-empty checkbox-radios">
              {this.state.opciones.map((val)=>{
                return this.renderARadio(val);
              })}
            </div>
    )
  }
}
export default Esponsors;

Esponsors.propTypes = {
    updateAction:PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    theKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/fields/Esponsors.js